// ── WORKSPACE SWITCHER (fp-nofodesk-9 follow-up) — extracted from App.js ──
import { TOKENS } from "../tokens";
import { FONT_UI, useT } from "../theme";
import { useWorkspace } from "../context/WorkspaceContext";

function WorkspaceSwitcher() {
  const { driveMode, wsOwner, memberOf, isLoaded, switchToPersonal, switchToTeam } = useWorkspace();
  const T = useT();
  if (!isLoaded || memberOf.length === 0) return null;
  const isTeam = driveMode === 'team' && wsOwner;
  const value = isTeam ? `team:${wsOwner}` : 'personal';
  const handleChange = (e) => {
    const v = e.target.value;
    if (v === 'personal') { switchToPersonal(); } else { switchToTeam(v.slice(5)); }
    window.location.reload();
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
      {isTeam && (
        <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.06em', color: TOKENS.gold, background: `${TOKENS.gold}22`, border: `1px solid ${TOKENS.gold}55`, borderRadius: 4, padding: '2px 6px', fontFamily: FONT_UI, textTransform: 'uppercase' }}>
          Team
        </span>
      )}
      <select
        value={value}
        onChange={handleChange}
        title={isTeam ? "Viewing team workspace — click to switch to your personal data" : "Viewing your personal data"}
        style={{ fontSize: 12, fontFamily: FONT_UI, background: T.bgCard, color: isTeam ? TOKENS.gold : T.textBase, border: `1px solid ${isTeam ? TOKENS.gold + '66' : T.borderDim}`, borderRadius: 6, padding: '3px 8px', cursor: 'pointer' }}
      >
        <option value="personal">Personal</option>
        {memberOf.map(ws => (
          <option key={ws.owner_id} value={`team:${ws.owner_id}`}>{ws.owner_id.split('@')[0]}</option>
        ))}
      </select>
    </div>
  );
}
export default WorkspaceSwitcher;
